// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICoveragePeriodDto } from './ICoveragePeriodDto';
import {
    ICoveragePeriodDtoFromJSON,
    ICoveragePeriodDtoFromJSONTyped,
    ICoveragePeriodDtoToJSON,
    ICoveragePeriodDtoToJSONTyped,
} from './ICoveragePeriodDto';
import type { IPolicyElectionDto } from './IPolicyElectionDto';
import {
    IPolicyElectionDtoFromJSON,
    IPolicyElectionDtoFromJSONTyped,
    IPolicyElectionDtoToJSON,
    IPolicyElectionDtoToJSONTyped,
} from './IPolicyElectionDto';

/**
 * 
 * @export
 * @interface IEnrollmentDto
 */
export interface IEnrollmentDto {
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    policy_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentDto
     */
    account_type?: string;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentDto
     */
    enrollment_title?: string;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentDto
     */
    display_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    available_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    election_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    plan_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IEnrollmentDto
     */
    plan_valid_from?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IEnrollmentDto
     */
    allow_investments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IEnrollmentDto
     */
    allow_individual_contributions?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    investment_threshold?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    minimum_investment_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentDto
     */
    account_status?: IEnrollmentDtoAccountStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentDto
     */
    cip_status?: IEnrollmentDtoCipStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IEnrollmentDto
     */
    cip_required?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    account_number_length?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof IEnrollmentDto
     */
    investment_option_types?: Array<IEnrollmentDtoInvestmentOptionTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentDto
     */
    enrollment_status?: IEnrollmentDtoEnrollmentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentDto
     */
    status?: IEnrollmentDtoStatusEnum;
    /**
     * 
     * @type {Array<ICoveragePeriodDto>}
     * @memberof IEnrollmentDto
     */
    coverage_periods?: Array<ICoveragePeriodDto>;
    /**
     * 
     * @type {Date}
     * @memberof IEnrollmentDto
     */
    submit_claims_date_end?: Date;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentDto
     */
    proof_of_expenses_type?: IEnrollmentDtoProofOfExpensesTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentDto
     */
    plan_code?: string;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    current_tax_year_employee_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    current_tax_year_employer_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    prior_tax_year_employee_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    prior_tax_year_employer_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    current_plan_year_employee_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    current_plan_year_employer_contribution_amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IEnrollmentDto
     */
    deductible_met?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof IEnrollmentDto
     */
    deductible_met_date?: Date;
    /**
     * 
     * @type {Set<string>}
     * @memberof IEnrollmentDto
     */
    deductible_types?: Set<IEnrollmentDtoDeductibleTypesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof IEnrollmentDto
     */
    contribution_monitoring_required?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IEnrollmentDto
     */
    generate_statements?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    minimum_contribution_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    catch_up_election?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    catch_up_age?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    current_rollover_remaining?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    prior_rollover_remaining?: number;
    /**
     * 
     * @type {Date}
     * @memberof IEnrollmentDto
     */
    remaining_rollover_balance_date?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IEnrollmentDto
     */
    is_replenished?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IEnrollmentDto
     */
    is_rollover?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    per_pay_employee?: number;
    /**
     * 
     * @type {number}
     * @memberof IEnrollmentDto
     */
    per_pay_employer?: number;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentDto
     */
    spend_period_type?: IEnrollmentDtoSpendPeriodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentDto
     */
    coverage_tier_type?: IEnrollmentDtoCoverageTierTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IEnrollmentDto
     */
    coverage_tier_effective_date?: Date;
    /**
     * 
     * @type {Array<IPolicyElectionDto>}
     * @memberof IEnrollmentDto
     */
    election_periods?: Array<IPolicyElectionDto>;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentDto
     */
    funding_method_type?: IEnrollmentDtoFundingMethodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IEnrollmentDto
     */
    omnibus_type?: IEnrollmentDtoOmnibusTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IEnrollmentDtoAccountStatusEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    PENDING = 'PENDING'
}
/**
* @export
* @enum {string}
*/
export enum IEnrollmentDtoCipStatusEnum {
    NONE = 'NONE',
    PENDING = 'PENDING',
    PASS = 'PASS',
    FAIL = 'FAIL',
    QUESTION = 'QUESTION',
    RENEWED = 'RENEWED',
    CIP_FAILED_ACCOUNT_CLOSE = 'CIP_FAILED_ACCOUNT_CLOSE'
}
/**
* @export
* @enum {string}
*/
export enum IEnrollmentDtoInvestmentOptionTypesEnum {
    MANAGED = 'MANAGED',
    SELF_DIRECTED = 'SELF_DIRECTED',
    BROKERAGE = 'BROKERAGE'
}
/**
* @export
* @enum {string}
*/
export enum IEnrollmentDtoEnrollmentStatusEnum {
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    FUTURE = 'FUTURE',
    EXPIRED = 'EXPIRED'
}
/**
* @export
* @enum {string}
*/
export enum IEnrollmentDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    FUTURE = 'FUTURE',
    EXPIRED = 'EXPIRED'
}
/**
* @export
* @enum {string}
*/
export enum IEnrollmentDtoProofOfExpensesTypeEnum {
    RECEIPT_REQUIRED = 'RECEIPT_REQUIRED',
    NO_RECEIPT_REQUIRED = 'NO_RECEIPT_REQUIRED'
}
/**
* @export
* @enum {string}
*/
export enum IEnrollmentDtoDeductibleTypesEnum {
    INDIVIDUAL_DEDUCTIBLE_MET = 'INDIVIDUAL_DEDUCTIBLE_MET',
    FAMILY_DEDUCTIBLE_MET = 'FAMILY_DEDUCTIBLE_MET'
}
/**
* @export
* @enum {string}
*/
export enum IEnrollmentDtoSpendPeriodTypeEnum {
    UNLIMITED = 'UNLIMITED',
    MONTHLY = 'MONTHLY',
    PLAN_YEAR = 'PLAN_YEAR'
}
/**
* @export
* @enum {string}
*/
export enum IEnrollmentDtoCoverageTierTypeEnum {
    S = 'S',
    F = 'F',
    EO = 'EO',
    ET = 'ET',
    EC = 'EC',
    ES = 'ES',
    ES1 = 'ES1',
    ES2 = 'ES2',
    ES3 = 'ES3',
    E1 = 'E1',
    E2 = 'E2',
    E3 = 'E3',
    OT = 'OT'
}
/**
* @export
* @enum {string}
*/
export enum IEnrollmentDtoFundingMethodTypeEnum {
    STANDARD_NOTIONAL = 'STANDARD_NOTIONAL',
    PREFUND_SPENDDOWN = 'PREFUND_SPENDDOWN',
    PREFUND_AND_CONTRIBUTION = 'PREFUND_AND_CONTRIBUTION',
    CONTRIBUTION_ONLY = 'CONTRIBUTION_ONLY'
}
/**
* @export
* @enum {string}
*/
export enum IEnrollmentDtoOmnibusTypeEnum {
    HSA = 'HSA',
    NOTIONAL = 'NOTIONAL'
}


/**
 * Check if a given object implements the IEnrollmentDto interface.
 */
export function instanceOfIEnrollmentDto(value: object): value is IEnrollmentDto {
    return true;
}

export function IEnrollmentDtoFromJSON(json: any): IEnrollmentDto {
    return IEnrollmentDtoFromJSONTyped(json, false);
}

export function IEnrollmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEnrollmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'policy_id': json['policy_id'] == null ? undefined : json['policy_id'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'enrollment_title': json['enrollment_title'] == null ? undefined : json['enrollment_title'],
        'display_name': json['display_name'] == null ? undefined : json['display_name'],
        'available_amount': json['available_amount'] == null ? undefined : json['available_amount'],
        'election_amount': json['election_amount'] == null ? undefined : json['election_amount'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan_valid_from': json['plan_valid_from'] == null ? undefined : (new Date(json['plan_valid_from'])),
        'allow_investments': json['allow_investments'] == null ? undefined : json['allow_investments'],
        'allow_individual_contributions': json['allow_individual_contributions'] == null ? undefined : json['allow_individual_contributions'],
        'investment_threshold': json['investment_threshold'] == null ? undefined : json['investment_threshold'],
        'minimum_investment_amount': json['minimum_investment_amount'] == null ? undefined : json['minimum_investment_amount'],
        'account_status': json['account_status'] == null ? undefined : json['account_status'],
        'cip_status': json['cip_status'] == null ? undefined : json['cip_status'],
        'cip_required': json['cip_required'] == null ? undefined : json['cip_required'],
        'account_number_length': json['account_number_length'] == null ? undefined : json['account_number_length'],
        'investment_option_types': json['investment_option_types'] == null ? undefined : json['investment_option_types'],
        'enrollment_status': json['enrollment_status'] == null ? undefined : json['enrollment_status'],
        'status': json['status'] == null ? undefined : json['status'],
        'coverage_periods': json['coverage_periods'] == null ? undefined : ((json['coverage_periods'] as Array<any>).map(ICoveragePeriodDtoFromJSON)),
        'submit_claims_date_end': json['submit_claims_date_end'] == null ? undefined : (new Date(json['submit_claims_date_end'])),
        'proof_of_expenses_type': json['proof_of_expenses_type'] == null ? undefined : json['proof_of_expenses_type'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'current_tax_year_employee_contribution_amount': json['current_tax_year_employee_contribution_amount'] == null ? undefined : json['current_tax_year_employee_contribution_amount'],
        'current_tax_year_employer_contribution_amount': json['current_tax_year_employer_contribution_amount'] == null ? undefined : json['current_tax_year_employer_contribution_amount'],
        'prior_tax_year_employee_contribution_amount': json['prior_tax_year_employee_contribution_amount'] == null ? undefined : json['prior_tax_year_employee_contribution_amount'],
        'prior_tax_year_employer_contribution_amount': json['prior_tax_year_employer_contribution_amount'] == null ? undefined : json['prior_tax_year_employer_contribution_amount'],
        'current_plan_year_employee_contribution_amount': json['current_plan_year_employee_contribution_amount'] == null ? undefined : json['current_plan_year_employee_contribution_amount'],
        'current_plan_year_employer_contribution_amount': json['current_plan_year_employer_contribution_amount'] == null ? undefined : json['current_plan_year_employer_contribution_amount'],
        'deductible_met': json['deductible_met'] == null ? undefined : json['deductible_met'],
        'deductible_met_date': json['deductible_met_date'] == null ? undefined : (new Date(json['deductible_met_date'])),
        'deductible_types': json['deductible_types'] == null ? undefined : new Set(json['deductible_types']),
        'contribution_monitoring_required': json['contribution_monitoring_required'] == null ? undefined : json['contribution_monitoring_required'],
        'generate_statements': json['generate_statements'] == null ? undefined : json['generate_statements'],
        'minimum_contribution_amount': json['minimum_contribution_amount'] == null ? undefined : json['minimum_contribution_amount'],
        'catch_up_election': json['catch_up_election'] == null ? undefined : json['catch_up_election'],
        'catch_up_age': json['catch_up_age'] == null ? undefined : json['catch_up_age'],
        'current_rollover_remaining': json['current_rollover_remaining'] == null ? undefined : json['current_rollover_remaining'],
        'prior_rollover_remaining': json['prior_rollover_remaining'] == null ? undefined : json['prior_rollover_remaining'],
        'remaining_rollover_balance_date': json['remaining_rollover_balance_date'] == null ? undefined : (new Date(json['remaining_rollover_balance_date'])),
        'is_replenished': json['is_replenished'] == null ? undefined : json['is_replenished'],
        'is_rollover': json['is_rollover'] == null ? undefined : json['is_rollover'],
        'per_pay_employee': json['per_pay_employee'] == null ? undefined : json['per_pay_employee'],
        'per_pay_employer': json['per_pay_employer'] == null ? undefined : json['per_pay_employer'],
        'spend_period_type': json['spend_period_type'] == null ? undefined : json['spend_period_type'],
        'coverage_tier_type': json['coverage_tier_type'] == null ? undefined : json['coverage_tier_type'],
        'coverage_tier_effective_date': json['coverage_tier_effective_date'] == null ? undefined : (new Date(json['coverage_tier_effective_date'])),
        'election_periods': json['election_periods'] == null ? undefined : ((json['election_periods'] as Array<any>).map(IPolicyElectionDtoFromJSON)),
        'funding_method_type': json['funding_method_type'] == null ? undefined : json['funding_method_type'],
        'omnibus_type': json['omnibus_type'] == null ? undefined : json['omnibus_type'],
    };
}

export function IEnrollmentDtoToJSON(json: any): IEnrollmentDto {
    return IEnrollmentDtoToJSONTyped(json, false);
}

export function IEnrollmentDtoToJSONTyped(value?: IEnrollmentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'policy_id': value['policy_id'],
        'account_type': value['account_type'],
        'account_id': value['account_id'],
        'enrollment_title': value['enrollment_title'],
        'display_name': value['display_name'],
        'available_amount': value['available_amount'],
        'election_amount': value['election_amount'],
        'plan_id': value['plan_id'],
        'plan_valid_from': value['plan_valid_from'] == null ? undefined : ((value['plan_valid_from']).toISOString().substring(0,10)),
        'allow_investments': value['allow_investments'],
        'allow_individual_contributions': value['allow_individual_contributions'],
        'investment_threshold': value['investment_threshold'],
        'minimum_investment_amount': value['minimum_investment_amount'],
        'account_status': value['account_status'],
        'cip_status': value['cip_status'],
        'cip_required': value['cip_required'],
        'account_number_length': value['account_number_length'],
        'investment_option_types': value['investment_option_types'],
        'enrollment_status': value['enrollment_status'],
        'status': value['status'],
        'coverage_periods': value['coverage_periods'] == null ? undefined : ((value['coverage_periods'] as Array<any>).map(ICoveragePeriodDtoToJSON)),
        'submit_claims_date_end': value['submit_claims_date_end'] == null ? undefined : ((value['submit_claims_date_end']).toISOString().substring(0,10)),
        'proof_of_expenses_type': value['proof_of_expenses_type'],
        'plan_code': value['plan_code'],
        'current_tax_year_employee_contribution_amount': value['current_tax_year_employee_contribution_amount'],
        'current_tax_year_employer_contribution_amount': value['current_tax_year_employer_contribution_amount'],
        'prior_tax_year_employee_contribution_amount': value['prior_tax_year_employee_contribution_amount'],
        'prior_tax_year_employer_contribution_amount': value['prior_tax_year_employer_contribution_amount'],
        'current_plan_year_employee_contribution_amount': value['current_plan_year_employee_contribution_amount'],
        'current_plan_year_employer_contribution_amount': value['current_plan_year_employer_contribution_amount'],
        'deductible_met': value['deductible_met'],
        'deductible_met_date': value['deductible_met_date'] == null ? undefined : ((value['deductible_met_date']).toISOString().substring(0,10)),
        'deductible_types': value['deductible_types'] == null ? undefined : Array.from(value['deductible_types'] as Set<any>),
        'contribution_monitoring_required': value['contribution_monitoring_required'],
        'generate_statements': value['generate_statements'],
        'minimum_contribution_amount': value['minimum_contribution_amount'],
        'catch_up_election': value['catch_up_election'],
        'catch_up_age': value['catch_up_age'],
        'current_rollover_remaining': value['current_rollover_remaining'],
        'prior_rollover_remaining': value['prior_rollover_remaining'],
        'remaining_rollover_balance_date': value['remaining_rollover_balance_date'] == null ? undefined : ((value['remaining_rollover_balance_date']).toISOString().substring(0,10)),
        'is_replenished': value['is_replenished'],
        'is_rollover': value['is_rollover'],
        'per_pay_employee': value['per_pay_employee'],
        'per_pay_employer': value['per_pay_employer'],
        'spend_period_type': value['spend_period_type'],
        'coverage_tier_type': value['coverage_tier_type'],
        'coverage_tier_effective_date': value['coverage_tier_effective_date'] == null ? undefined : ((value['coverage_tier_effective_date']).toISOString().substring(0,10)),
        'election_periods': value['election_periods'] == null ? undefined : ((value['election_periods'] as Array<any>).map(IPolicyElectionDtoToJSON)),
        'funding_method_type': value['funding_method_type'],
        'omnibus_type': value['omnibus_type'],
    };
}

